import {AudioTreatment} from './audio'
import {CallTreatmentsSelect} from './treatments_select'
import {EndpointTreatment} from './endpoint_treatment'
import {HangupTreatment} from './hangup'
import {HuntOrderTreatment} from './hunt_order'
import {IVRMenuTreatment} from './ivr_menu'
import {PostCallTreatment} from './postcall'
import {SimRingTreatment} from './simring'
import {SMSTreatment} from './sms'
import {TodTreatment} from './tod'
import {TreatmentFlow} from './treatment'
import {TreatmentTarget} from './treatment_target'
import {WebhookTreatment} from './webhook'
require('../slide-in')

export class CallTreatment extends HTMLElement {

    constructor(showParent) {
      super();
      this.showParent = showParent;
    }

    async save() {
      let validationResult = this.validate();
      // parse validationResult
      this.querySelector(".treatment_details .errors").innerHTML = ''
      if(validationResult.requiredMissing == true || validationResult.errorMessages.length > 0) {
        let errorMessages = ``;
        if(validationResult.requiredMissing == true) {
          errorMessages += `<div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <strong>Warning!</strong> The Call Treatment is incomplete.
            </div>`
        }
        validationResult.errorMessages.forEach(function(errorMessage) {
          errorMessages += `<div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <strong>Warning!</strong> ${errorMessage}
            </div>`
        });

        this.querySelector(".treatment_details .errors").innerHTML = errorMessages;
      } else {
        panel_refresh($('#call_treatment_path'));  // UNCOMMENT
        let child = {option: null, destination: null, actions:[]}
        // The first target is just a container for the rest of the targets.
        let treatment = {
              target_id: this.treatment_id != null ? this.treatment_id : null,
              target_name: $("#treatment_title").val(),
              target_type: "TREATMENT",
              ring_to_number: null,
              ivr_target_audio_id: null,
              ivr_choice_timeout: null,
              children:[child],
              actions: []
            }
        this.querySelector("treatment-flow").getData(child);
        console.log(treatment);

        let domain_id = document.querySelector("#object_id").value
        let res = await fetch('/admin/domains/'+domain_id+'/call_treatments', {
            headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                      'Content-type': 'application/json'},
            method: 'POST',
            body: JSON.stringify(treatment)
          })
        let data = await res.json();
        if(data.success) {
          panel_refresh($('#call_treatment_path'));
          panel_refresh($('#call_treatments_list'));
          this.cancel();
          TreatmentsManager.reloadTreatments(() => panel_refresh($('#call_treatments_list')));
        } else {
          alert("Sorry an error occured and was unable to save.");
          panel_refresh($('#call_treatment_path'));
        }

      }

    }

    validate() {
      let validationResult = this.querySelector("treatment-flow").validate();
      this.querySelector("#treatment_title").classList.remove("error");
      if(this.querySelector("#treatment_title").value == "") {
        this.querySelector("#treatment_title").classList.add("error");
        validationResult.requiredMissing = true
      }
      if(this.querySelector('.hunt_ordered_rna')) {
        this.querySelectorAll('.hunt_ordered_rna').forEach(elem => {
          if(elem.value < 5) {
            elem.classList.add("error");
            validationResult.requiredMissing = true
          }
        })
      }
      return validationResult
    }

    cancel() {
      // this.treatment_id = null;
      // let treatment_flow = document.createElement("treatment-flow");
      // treatment_flow.appendChild(document.createElement("treatment-element"));
      // this.querySelector("#call_treatment_flow > .treatments_container").innerHTML = "";
      // this.querySelector("#call_treatment_flow > .treatments_container").appendChild(treatment_flow);
      // this.querySelector("#treatment_title").value = "";
      this.remove();
      $("#call_treatment_path").hide();
      $("#call_treatments_list").show();
      this.showParent();
    }

    async loadCallTreatment(id) {
      panel_refresh($('#call_treatment_path'));
      this.treatment_id = id;
      let domain_id = document.querySelector("#object_id").value
      let res = await fetch('/admin/domains/'+domain_id+'/call_treatments/'+id);
      let data = await res.json();
      this.querySelector("#treatment_title").value = data.target_name;

      this.querySelector(".treatments_container").innerHTML = "<treatment-flow></treatment-flow>";
      let flow = this.querySelector(".treatments_container > treatment-flow")
      flow.renderFlow(data.children[0]);

      panel_refresh($('#call_treatment_path'));
    }

    connectedCallback() {
      this.innerHTML =
      `
      <div class="row">
        <div class="treatment_details slide_adjust_col_8">
          <h3><span class="title">Create</span> Treatment</h3>
          <p>Build your call treatment</p>
          <div class="errors"></div>
          <div class="form-group" style="margin:10px 0px;">
            <label>Name</label>
            <input type="text" class="form-control" id="treatment_title" placeholder="Name">
          </div>
        </div>
      </div>
      <div class="row" id="call_treatment_flow">
        <div class="treatments_container slide_adjust_col_8">
          <treatment-flow>
            <treatment-element></treatment-element>
          </treatment-flow>
        </div>
      </div>
      <div class="row">
        <div class="slide_adjust_col_8 buttons">
          <input id=SaveCallTreatment type=button value='Save' class='btn btn-primary pull-right' title=Save>
          <input id=CancelCallTreatment type=button value='Cancel' class='btn btn-outline-secondary pull-right' title=Cancel>
        </div>
      </div>
      <slide-in src=/call_treatment_help.html><i slot="open" class="fa fa-question-circle-o fa-2x"></i><i slot="close" class="fa fa-times fa-2x"></i></slide-in>
      `;
      //Call Treatment audio modal ^

      this.querySelector("#SaveCallTreatment").addEventListener('click', this.save.bind(this));
      this.querySelector("#CancelCallTreatment").addEventListener('click', this.cancel.bind(this));
    }
  }
  customElements.define('call-treatment', CallTreatment);
